<script>
import { mapActions, mapGetters } from "vuex";

import Tip from "@/components/_base/Tip";

export default {
  components: {
    Tip
  },

  data() {
    return {
      timeout: null
    };
  },

  methods: {
    ...mapActions("orderCancellation", ["setCancellationReason"]),

    updateCancellationReason(event) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(
        () => this.setCancellationReason(event.target.value),
        1000
      );
    }
  },

  computed: {
    ...mapGetters("orderCancellation", [
      "isShortNotice",
      "isCancellationPossible"
    ])
  }
};
</script>

<template>
  <div class="reason">
    <div class="text" v-if="isCancellationPossible">
      Motivo do cancelamento

      <textarea
        placeholder="Por favor, você pode nos dizer um pouco do porque você deseja cancelar a limpeza?"
        rows="5"
        @input="updateCancellationReason"
      >
      </textarea>
    </div>

    <div class="alert" v-if="isShortNotice || !isCancellationPossible">
      <Tip type="alert" v-if="!isCancellationPossible">
        Agendamentos cancelados com menos de 3h de antecedência serão considerados como completo e o profissional receberá o valor integral da limpeza, mesmo que ele não seja recebido.
      </Tip>

      <Tip type="alert" v-else>
        Atenção, cancelamento entre 24h e 3h úteis o cliente perde 1h para que a profissional seja compensada pelo dia de trabalho ocupado.
      </Tip>

      <router-link :to="{name: 'help'}">
        Veja todas as regras de cancelamento aqui
    </router-link>
    </div>
  </div>
</template>

<style scoped>
.reason {
  color: #424242;
  font-weight: 400;
  font-size: 14px;
  width: 100%;
}

textarea {
  width: calc(100% - 24px - 2px);
  margin: 4px auto 0;
  padding: 12px;
}

.alert {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.alert > a {
  margin-top: 4px;
  color: #cfb2c4;
  text-decoration: underline;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Components/Actions/Cancellation/CancellationData.vue